import {
  VideoBase,
  VideoContent,
  VideoDate,
  VideoDescription,
  VideoPlayer,
  VideoThumbnail,
  VideoTitle,
} from '@/app_components/Video/Video';
import type { AdTags } from '@/app_lib/services/ads/defaults';
import type { Video } from '@/app_lib/types/Video';

interface VideoDefaultProps {
  modal?: boolean;
  orientation?: 'horizontal' | 'vertical';
  showDescription?: boolean;
  target?: string;
  watching?: boolean;
  video: Video;
  className?: string;
  'data-index'?: number;
  playing?: boolean;
  adTags?: AdTags[];
}

export const VideoDefault = ({
  watching = false,
  modal = false,
  orientation,
  showDescription = false,
  target,
  video,
  className,
  adTags,
  playing = false,
  'data-index': index,
}: VideoDefaultProps) => {
  return (
    <VideoBase
      className={className}
      modal={modal}
      orientation={orientation}
    >
      {playing ? (
        <VideoPlayer
          adTags={adTags}
          layout='default'
          modal={modal}
          orientation='vertical'
          target={target}
          videoId={video.id}
        />
      ) : (
        <VideoThumbnail
          className={target}
          data-index={index}
          duration={video.duration}
          modal={modal}
          orientation={orientation}
          src={video.thumbnail}
          watching={watching}
        />
      )}
      <VideoContent
        modal={modal}
        orientation={orientation}
      >
        <VideoTitle
          className={target}
          data-index={index}
          modal={modal}
          orientation={orientation}
          playing={playing}
          title={video.title}
          watching={watching}
        />
        {showDescription && (
          <VideoDescription
            description={video.summary}
            modal={modal}
            orientation={orientation}
          />
        )}
        <VideoDate
          date={video.age}
          modal={modal}
          orientation={orientation}
        />
      </VideoContent>
    </VideoBase>
  );
};
